<template>
    <t-form :onSubmit="sendPhoneNumber" :schema="phoneNumberSchema" id="phone_number_form">
        <div class="subtitle"><span>{{$translation($websiteText().sign_up_login_popup_phone_verification_text)}} </span></div>
        <div class="input-content">
            <t-input-select
              :options="$store.getters.phoneCodes"
              :filter="true"
              optionValue="dial_code"
              optionLabel="dial_code"
              v-model="phoneDial"
              :displayError="true"
              optionLabel1="name"
              filterLabel="name"
              name="phone_dial"
              placeholder="+123"
              style="height: 31px;"
              :filterFields="['dial_code', 'name']"
            ></t-input-select>
            <t-input-text
              v-model="phoneNumber"
              name="phone_number"
              :displayError="true"
              placeholder="01 23 45 67 89"
              rootStyle="height:31px"
           
            />
        </div>
    </t-form>

    <t-form :onSubmit="verifyPhoneNumber" :schema="verificationCodeSchema" id="verification_number_form">
        <div class="input-content">
            <t-input-text
              v-model="verificationCode"
              name="verification_code"
              :displayError="true"
              placeholder="Verification Code"
              :style="'width:100%; height:25px'"
              rootStyle="width:100%; margin-right:10px; height:25px"
              
            />
            <t-button
              style="padding: 10px;; width:200px"
              type="submit"
              :label="sendCodebtnlabel ? sendCodebtnlabel:$translation($websiteText().sign_up_login_popup_send_code)"
              :disabled="sendCodeBtn || !phoneDial.length || !phoneNumber.length"
              color="primary-color"
              formSubmit="phone_number_form"
              ref="send_code_btn"
            />
          
        </div>
    </t-form>
    <div id="recapacha"> </div>

    
    <div v-if="showNote && !verificationCode.length" class="note">
      Verification code may take up to 10 minutes to reach your phone.
    </div>
    
    <div class="form">
        <div class="submit-btn-container" playwright-id='submit'>
          <t-button
            type="submit"
            :label="$translation($websiteText().sign_up_login_popup_submit_code)"
            color="primary-color"
            buttonClass="signin-btn-class"
            formSubmit="verification_number_form"
            :disabled="verificationCode.length ? false : true"
            
          />
        </div>
        
      <div class="footer-line">

        <div style="display: flex; flex-direction: row; text-align:center">
            <div class="account">{{$translation($websiteText().sign_up_login_popup_already_have_an_account)}}</div>
            
            <button
              class="nobutton"
              style="padding: 0px; margin-bottom: 5%"
              @click="() => goToLogin()"
            >
            <div class="signup-btn">{{$translation($websiteText().sign_up_login_popup_login_here_button)}}</div>
            </button>
        </div>
    </div>
</div>
</template>

<script>
import store from "../../../store";
import { useStore } from "vuex";

import ForgetPassword from "./ForgetPassword.vue";
import GeneralVariables from "../../../common/utils/GeneralVariables";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import Register from "./Register.vue";
import Signin from "./Signin.vue";

import TInputText from "../../../common/components/input-text/TInputText.vue";
import TForm from "../../../common/components/TForm.vue";
import TInputSelect from "../../../common/components/input-text/TInputSelect.vue";
import TButton from "../../../common/components/buttons/TButton.vue";
import {
  AUTH_REQUEST,
  AUTH_LOGOUT,
  GOOGLE_AUTH_REQUEST,
  REPLACE_AUTH_ACTIVE_COMPONENT,
SEND_VERIFICATION_CODE,
CHECK_VERIFICATION_CODE,
} from "../store/actions";
import * as Yup from "yup";

import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, signInWithCustomToken, PhoneAuthProvider, updatePhoneNumber   } from 'firebase/auth'
export default{
 name:"VerifyPhoneNumber",
 components:{
    TInputText,
    TForm,
    TInputSelect,
    TButton

 },
 
 data()
 {
    return{
        phoneDial:'',
        phoneNumber:"",
        verificationCode:"",
        verificationId:null,
        sendCodeBtn:false,
        submitCodeBtn:true,
        sendCodebtnlabel:"",
        showNote:false
    }
 },
 methods:
 {
    sendPhoneNumber()
    {   
        let countdownTime = 60;
        this.sendCodeBtn = true
        this.showNote = true
        
        this.sendCodebtnlabel = 'Resend in '+ countdownTime + 's'
        const interval = setInterval(()=>{
          countdownTime -= 1;
          this.sendCodebtnlabel = 'Resend in '+ countdownTime + 's'
          if(countdownTime === 0){
            clearInterval(interval)
            this.sendCodeBtn=false
            this.sendCodebtnlabel = '' 
          }
        },1000)
        


        let data = {
            email:this.email,
            phone_number:this.phoneDial+this.phoneNumber
        }
        // this.$store.dispatch(SEND_VERIFICATION_CODE,data)
        
        const phoneNumber = data.phone_number;
        const appVerifier = window.recaptchaVerifier;
        let auth = this.auth
        let that = this

      

        let phoneProvider = new PhoneAuthProvider(this.auth)
        
        phoneProvider.verifyPhoneNumber(phoneNumber,appVerifier)
          .then(function (verificationId) {
            //this.showNote = false
            that.verificationId = verificationId;
            that.$store.dispatch(SHOW_TOAST_MESSAGE,GeneralHelper.buildMessage(1,"Please enter the verification code that was sent to your mobile device."))
            
        }).catch((e)=>{
          this.showNote = false
          that.$store.dispatch(SHOW_TOAST_MESSAGE,GeneralHelper.buildMessage(3, e))
          clearInterval(interval)
          this.sendCodeBtn=false
          this.sendCodebtnlabel = '' 
        }).finally(()=>{
            grecaptcha.reset(window.recaptchaVerifier.widgetId)
          })  
    },

    async verifyPhoneNumber()
    {
        let data = {
            email:this.email,
            phoneNumber:this.phoneDial+this.phoneNumber,
            custom_token: this.firebase_custom_token
        }

        let phoneCredential = PhoneAuthProvider.credential(this.verificationId, this.verificationCode);
        try{
            await updatePhoneNumber(this.auth.currentUser,phoneCredential);
            this.$store.dispatch(CHECK_VERIFICATION_CODE,data)
        }
        catch{
            this.$store.dispatch(SHOW_TOAST_MESSAGE,GeneralHelper.buildMessage(3,"Phone number already associated with an account!"))
        }
        
    }
 },
 setup(props)
 {
    const store = useStore()
    const goToResetComponent = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, ForgetPassword);
    };

    const goToRegisterComponent = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, Register);
    };

    const goToLogin = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, Signin);
    };

    const phoneNumberSchema = 
    Yup.object().shape({
      
      phone_dial: Yup.string()
        .required()
        .label("Phone dial"),
      phone_number: Yup.string()
        .required()
        .label("Phone number"),
    });

    const verificationCodeSchema = 
    Yup.object().shape({
        verification_code: Yup.string()
        .required()
        .label("Verification Code"),
    });

    const firebaseConfig = {
        apiKey: "AIzaSyDohVm26TvQ2GtBHTbSvV_KXWlynvCaaNg",
        authDomain: "toposmsauth.firebaseapp.com",
        projectId: "toposmsauth",
        storageBucket: "toposmsauth.appspot.com",
        messagingSenderId: "146691046637",
        appId: "1:146691046637:web:8ffb19d5b7289577aee0e4"
    };

    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);

    return {
        goToResetComponent,
        goToRegisterComponent,
        goToLogin,
        phoneNumberSchema,
        verificationCodeSchema,
        firebaseConfig,
        app,
        auth
    }
 },
 async mounted()
 {
  
    window.recaptchaVerifier = new RecaptchaVerifier(this.auth, 'recapacha', {
    'size': 'invisible',
    'callback': (response) => {
    }
    });
    signInWithCustomToken(this.auth, this.firebase_custom_token)
 },
 props:
 {
    email:{
        type:String,
        default:""
    },
    firebase_custom_token:{
        type:String,
        default:""
    },

 }
}

</script>


<style lang="scss" scoped>

  @import '../style/auth.scss';

  .account {
    @include f-button1;
    color: $light-black;
    font-weight: 600;
    vertical-align: middle;
    margin-right: 2px;
  }
  .signup-btn {
    @include f-button1;
    color: $brand-color;
    font-weight: bold;
    text-decoration: underline;
  }

  
  .agree {
    color: $light-black;
    margin-bottom: 12px;
    @include f-button1;
    cursor: pointer;
    text-align: flex-start;
    :hover{
      text-decoration: underline !important;
      color: $tertiary-color !important;
    }

    
}
.input-content{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.send-code-button {
  border: 1px solid $primary-color;
  background: $primary-color !important;
  color: white !important;
  border-radius: 4px;
  @include f-button1;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: $primary-color;
    color: white;
  }
  &:enabled:focus {
    box-shadow: 3px 3px 4px $grey;
    background: $primary-color;
    color: white;
  }
  height: 31px;
}

.note{
  @include f-label;
  font-size: 12px;
  font-weight: bold;
  color: $primary-color;
  margin-top: 10px;
}
</style>

<style>
.p-dropdown-panel{
    z-index: 99999999999 !important;
}

.p-inputtext {
  align-self: center;
}


</style>